@import "src/styles/common/_colors.scss";
.infoBlock {
  padding: unset;
  background-color: unset;
  border: unset;
  color: $blue;
  cursor: pointer;
}

